import { render, staticRenderFns } from "./InspectionApproval.vue?vue&type=template&id=5a18a893&scoped=true&"
import script from "./InspectionApproval.vue?vue&type=script&lang=ts&"
export * from "./InspectionApproval.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionApproval.vue?vue&type=style&index=0&id=5a18a893&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a18a893",
  null
  
)

export default component.exports